/**
 * Loading Spinner Component - Themed loading indicator
 */

import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const LoadingSpinner = ({
  size = 'md', // 'sm', 'md', 'lg'
  color = 'primary', // 'primary', 'secondary', 'white'
  className = '',
  style = {}
}) => {
  const { theme } = useTheme();

  const getSizeStyles = () => {
    switch (size) {
      case 'sm':
        return {
          width: '1.5rem',
          height: '1.5rem',
          borderWidth: '2px'
        };
      case 'lg':
        return {
          width: '3rem',
          height: '3rem',
          borderWidth: '4px'
        };
      default: // md
        return {
          width: '2rem',
          height: '2rem',
          borderWidth: '3px'
        };
    }
  };

  const getColor = () => {
    switch (color) {
      case 'secondary':
        return theme.colors.textSecondary;
      case 'white':
        return 'var(--color-text)';
      default:
        return theme.colors.primary;
    }
  };

  const spinnerColor = getColor();
  const sizeStyles = getSizeStyles();

  const baseStyles = {
    display: 'inline-block',
    border: `${sizeStyles.borderWidth} solid ${theme.colors.surface}`,
    borderTop: `${sizeStyles.borderWidth} solid ${spinnerColor}`,
    borderRadius: '50%',
    width: sizeStyles.width,
    height: sizeStyles.height,
    animation: 'spin 1s linear infinite',
    ...style
  };

  return (
    <div className={`loading-spinner ${className}`} style={baseStyles}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingSpinner;